import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import image from "../../assets/product-list-assets/switches/aggregation/hi-capacity-aggregation.jpg";
import v3Image from "../../assets/Switching/highCapacityAggregation.jpg";
import type { Product } from "../../types";
import { aggregation } from "../product-groups/switching/aggregation";
import { productListSwitchingProfessional } from "../product-list-groups/productListSwitchingProfessional";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const highCapacityAggregation: Product = {
  id: "hiCapacityAggregation",
  productTitle: "Hi-Capacity Aggregation",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-pro-aggregation"],
  storePathParts: {
    productSlug: "usw-pro-aggregation",
    category: UniFiChildCategorySlug.SwitchingAggregation,
  },
  sku: "USW-Pro-Aggregation",
  description: "hiCapacityAggregation.description",
  image: { src: image, width: 200, height: 140 },
  v3Image: {
    src: v3Image,
    width: 252,
    height: 120,
  },
  productListGroup: productListSwitchingProfessional,
  productGroup: aggregation,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '442 x 325 x 44 mm\n(17.4 x 12.8 x 1.7")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer3",
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "32" },
    },
    {
      propertyId: downlinkSpeed.id,
      value: { type: "string", value: "10 Gbps" },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "25 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "generalRedundancy",
      value: {
        type: "translation",
        value: "commons.powerRedundancy.unifiPowerBackupReady",
      },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.rack",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
  ],
};
